import endpoints from '@/utils/constants';
import { apiHelper, authHelper } from '@/utils/helpers';

const actions = {
    saveService(context) {
        return new Promise((resolve, reject) => {
            apiHelper.call('post', `${endpoints.BASE_URL}${endpoints.API.services}`, context.state.service).then((res) => {
                if (res.status === 201) {
                    resolve(res.data)
                }
            }).catch(err => {
                reject(err)
            })
        })
    },

    getServiceList(context) {
        return new Promise((resolve, reject) => {
            apiHelper.call('get', `${endpoints.BASE_URL}${endpoints.API.services}`).then((res) => {
                if (res.status === 200) {
                    context.commit('setServiceList', res.data);
                }
            }).catch(err => {
                reject(err);
            })
        })
    },


    fetchService(context, serviceId) {
        return new Promise((resolve, reject) => {
            apiHelper.call('get', `${endpoints.BASE_URL}${endpoints.API.services}/${serviceId}`).then((res) => {
                if (res.status === 200) {
                    resolve(res.data);
                }
            }).catch(err => {
                reject(err);
            })
        })
    },

    updateService(context) {
        return new Promise((resolve, reject) => {
            apiHelper.call('put', `${endpoints.BASE_URL}${endpoints.API.services}/${context.state.service.serviceId}`, context.state.service).then((res) => {
                if (res.status === 200) {
                    context.commit('setService', res.data);
                    resolve(res);
                }
            }).catch(err => {
                reject(err);
            })
        });
    },

    getServicesByCategoryId(_, payload) {
        const { serviceCategoryId, ...query} = payload;
        const url = new URL(`${endpoints.BASE_URL}${endpoints.API.services}/service-category/${serviceCategoryId}`);
        if (query) {
            url.search = new URLSearchParams(query);
        }
        return new Promise((resolve, reject) => {
            apiHelper.call('get', url)
            .then(res => {
                if(res.status === 200) {
                    resolve(res.data)
                }
            }).catch(err => {
                reject(err)
            })
        })
    }


}
export default actions;